<template>
  <div class="fill-height">
    <div class="fill-height d-flex flex-column justify-center align-center">
      <h1 class="text-h2 grey--text text--darken-3">
        Welcome to
        <span class="primary--text font-weight-thin">masterTime</span>
      </h1>
      <div
        v-if="user && user.email"
        class="mt-6"
        style="font-size: 28px; color: #555"
      >
        {{ user.email }}
      </div>
      <div
        v-else
        class="mt-6 d-flex flex-column align-center"
        style="font-size: 28px; color: #555"
      >
        <div>{{ user.fullName }}</div>
        <div>รหัส : {{ user.employee_code }}</div>
        <div>
          บทบาท :
          <span v-if="employeePolicy.personal_policy_uuid"
            ><v-chip
              color="cyan"
              text-color="white"
              small
              class="mr-2 my-1"
              :key="employeePolicy.employee_uuid"
            >
              ส่วนตัว
            </v-chip></span
          >
          <span v-if="employeePolicy.roles && employeePolicy.roles.length > 0">
            <v-chip
              small
              class="mr-2 my-1"
              v-for="role in employeePolicy.roles"
              :key="role.role_uuid"
            >
              {{ role.title }}
            </v-chip>
          </span>
          <span v-else>-</span>
        </div>
      </div>

      <div class="mt-16 text-center">
        <div class="red--text" style="font-weight: 600">
          ข้อมูล Transaction จะถูกบันทึกเป็นเวลาสูงสุด
          {{ company.data_retention_period }} เดือน
          หลังจากนั้นข้อมูลจะถูกลบอัตโนมัติ
        </div>
        <div
          class="mt-2 grey--text text--darken-3 body-2"
          style="font-weight: 500"
        >
          ข้อมูล Transaction เก่าที่สุด ณ วันนี้คือ
          {{ oldestTransactionDate }}
        </div>
        <div v-if="company.activate_end_date">
          <v-divider class="my-4"></v-divider>
          <div
            class="mt-2 grey--text text--darken-3 body-2"
            style="font-weight: 500"
          >
            <span
              style="font-weight: 600"
              :class="{ 'red--text': isExpiringWithinMonth }"
            >
              Web Application สามารถใช้งานได้จนถึงวันที่
              {{ company.activate_end_date | formatDate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialogAnnouncement"
      scrollable
      persistent
      max-width="600"
    >
      <v-card v-if="currentAnnouncement">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ currentAnnouncement.title }}</span>
          <v-btn icon @click="dialogAnnouncement = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
          {{
            (currentAnnouncement.sent_datetime ||
              currentAnnouncement.created_at) | dateTimeFormat
          }}
        </v-card-subtitle>
        <v-card-text style="max-height: 60vh">
          <div style="white-space: pre-line">
            {{ currentAnnouncement.message }}
          </div>
          <v-carousel
            v-if="currentAnnouncementImages.length > 1"
            hide-delimiter-background
            height="300"
            class="mt-2"
          >
            <v-carousel-item
              v-for="file in currentAnnouncementImages"
              :key="file.announcement_image_uuid"
            >
              <v-img
                :src="file.image_url"
                width="100%"
                height="300"
                contain
                style="border: 1px solid #e0e0e0; border-radius: 5px"
              ></v-img>
            </v-carousel-item>
          </v-carousel>
          <v-img
            v-else-if="currentAnnouncementImages.length === 1"
            :src="currentAnnouncementImages[0].image_url"
            width="100%"
            height="300"
            contain
            class="mt-2"
            style="border: 1px solid #e0e0e0; border-radius: 5px"
          ></v-img>
        </v-card-text>
        <v-card-actions
          v-if="sentAnnouncements.length > 0"
          class="d-flex flex-column align-start"
        >
          <v-checkbox
            v-model="dontShowAgain"
            dense
            hide-details
            class="mt-0 mb-2 pt-0"
          >
            <template v-slot:label>
              <span class="body-2">ไม่ต้องแสดงประกาศนี้อีก</span>
            </template>
          </v-checkbox>
          <div class="d-flex align-center" style="width: 100%">
            <span class="grey--text body-2">
              {{ currentAnnouncementIndex + 1 }} /
              {{ sentAnnouncements.length }}
            </span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="primary"
              :disabled="!hasPrevAnnouncement"
              @click="prevAnnouncement"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn
              icon
              color="primary"
              :disabled="!hasNextAnnouncement"
              @click="nextAnnouncement"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

const SHOW_LOGIN_ANNOUNCEMENT_KEY = 'show-login-announcement'

function getAnnouncementUuid(announcement) {
  return (
    announcement?.announcement_uuid ||
    announcement?.system_announcement_uuid ||
    announcement?.announcement?.announcement_uuid ||
    announcement?.announcement?.system_announcement_uuid ||
    announcement?.system_announcement?.announcement_uuid ||
    announcement?.system_announcement?.system_announcement_uuid
  )
}

function getIsNotShowAgain(announcement) {
  return (
    !!announcement?.announcement_receiver?.is_not_show_again ||
    !!announcement?.system_announcement_receiver?.is_not_show_again
  )
}

export default {
  name: 'Home',
  data() {
    return {
      dialogAnnouncement: false,
      currentAnnouncementIndex: 0,
      readAnnouncementUuids: [],
      notShowAgainSyncedUuids: [],
      pendingNotShowAgainUuids: [],
    }
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: true },
    ])

    if (!this.user?.email) {
      this.loadDataApi()
    }

    if (sessionStorage.getItem(SHOW_LOGIN_ANNOUNCEMENT_KEY)) {
      sessionStorage.removeItem(SHOW_LOGIN_ANNOUNCEMENT_KEY)
      this.loadLoginAnnouncements()
    }
  },
  watch: {
    dialogAnnouncement(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.syncNotShowAgainAnnouncements()
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.authentication.user
    },
    company() {
      return this.$store.state.company.company
    },
    employeePolicy() {
      return this.$store.state.employeePolicy.employeePolicy
    },
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    announcementsSystem() {
      return this.$store.state.announcement.announcementsSystem
    },
    announcementsInternal() {
      return this.$store.state.announcement.announcementsInternal
    },
    sentAnnouncements() {
      const internal = (this.announcementsInternal || [])
        .filter((item) => item.sent_datetime)
        .map((item) => ({
          ...item,
          announcement_uuid: getAnnouncementUuid(item),
          announcement_source: 'internal',
        }))
      const system = (this.announcementsSystem || [])
        .filter((item) => item.sent_datetime)
        .map((item) => ({
          ...item,
          announcement_uuid: getAnnouncementUuid(item),
          announcement_source: 'system',
        }))

      return [...internal, ...system]
        .filter(
          (item) =>
            !getIsNotShowAgain(item) &&
            !this.notShowAgainSyncedUuids.includes(item.announcement_uuid)
        )
        .sort((a, b) => new Date(b.sent_datetime) - new Date(a.sent_datetime))
    },
    currentAnnouncement() {
      return this.sentAnnouncements[this.currentAnnouncementIndex] || null
    },
    currentAnnouncementImages() {
      const announcement = this.currentAnnouncement
      const images =
        announcement?.announcement_image ||
        announcement?.system_announcement_image ||
        announcement?.announcement?.announcement_image ||
        announcement?.announcement?.system_announcement_image ||
        announcement?.system_announcement?.announcement_image ||
        announcement?.system_announcement?.system_announcement_image ||
        []

      return images.map((file, index) => ({
        ...file,
        announcement_image_uuid:
          file.announcement_image_uuid || file.image_uuid || index,
        image_url: file.image_url || file.url,
      }))
    },
    hasNextAnnouncement() {
      return this.currentAnnouncementIndex < this.sentAnnouncements.length - 1
    },
    hasPrevAnnouncement() {
      return this.currentAnnouncementIndex > 0
    },
    dontShowAgain: {
      get() {
        if (!this.currentAnnouncement) return false
        const uuid = this.currentAnnouncement.announcement_uuid
        return (
          getIsNotShowAgain(this.currentAnnouncement) ||
          this.notShowAgainSyncedUuids.includes(uuid) ||
          this.pendingNotShowAgainUuids.includes(uuid)
        )
      },
      set(value) {
        if (!this.currentAnnouncement) return

        const uuid = getAnnouncementUuid(this.currentAnnouncement)
        if (!uuid) return

        const index = this.pendingNotShowAgainUuids.indexOf(uuid)

        if (value && index === -1) {
          this.pendingNotShowAgainUuids.push(uuid)
        } else if (!value && index !== -1) {
          this.pendingNotShowAgainUuids.splice(index, 1)
        }
      },
    },
    oldestTransactionDate() {
      const today = new Date()
      const retentionMonths = this.company.data_retention_period || 0
      const oldestDate = new Date(
        today.getFullYear(),
        today.getMonth() - retentionMonths,
        today.getDate()
      )
      return oldestDate.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    },
    isExpiringWithinMonth() {
      if (!this.company.activate_end_date) return false
      const today = new Date()
      const endDate = new Date(this.company.activate_end_date)
      const oneMonthFromNow = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        today.getDate()
      )

      return endDate <= oneMonthFromNow
    },
  },
  filters: {
    formatDate(date) {
      if (!date) return '-'
      const dateObj = new Date(date)
      return dateObj.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    },
    dateTimeFormat(value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm') : '-'
    },
  },
  methods: {
    ...mapActions({
      getEmployeePolicy: 'employeePolicy/getEmployeePolicy',
      fetchCompany: 'company/fetchCompany',
      fetchAnnouncementSystem: 'announcement/fetchAnnouncementSystem',
      fetchAnnouncementInternal: 'announcement/fetchAnnouncementInternal',
      addSystemAnnouncementIsRead: 'announcement/addSystemAnnouncementIsRead',
      addSystemAnnouncementIsNotShowAgain:
        'announcement/addSystemAnnouncementIsNotShowAgain',
      addAnnouncementIsRead: 'announcement/addAnnouncementIsRead',
      addAnnouncementIsNotShowAgain:
        'announcement/addAnnouncementIsNotShowAgain',
    }),
    async loadLoginAnnouncements() {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('modal:::announcement:receiver')
      ) {
        return
      }

      try {
        const { company_uuid } = this.$store.state.authentication.company
        const employee_uuid = this.$store.state.authentication.user?.uuid

        const params = {
          limit: '10,0',
          is_display_during_period: true,
        }

        await Promise.all([
          this.fetchAnnouncementInternal({
            company_uuid,
            employee_uuid,
            params,
          }),
          this.fetchAnnouncementSystem({
            company_uuid,
            employee_uuid,
            params,
          }),
        ])

        if (this.sentAnnouncements.length) {
          this.currentAnnouncementIndex = 0
          this.dialogAnnouncement = true
          this.markCurrentAnnouncementAsRead()
        }
      } catch (error) {
        // Silently ignore so it doesn't block the home screen after login
      }
    },
    nextAnnouncement() {
      if (this.hasNextAnnouncement) {
        this.currentAnnouncementIndex++
        this.markCurrentAnnouncementAsRead()
      }
    },
    prevAnnouncement() {
      if (this.hasPrevAnnouncement) {
        this.currentAnnouncementIndex--
        this.markCurrentAnnouncementAsRead()
      }
    },
    async syncNotShowAgainAnnouncements() {
      const allAnnouncements = [
        ...(this.announcementsInternal || []).map((item) => ({
          ...item,
          announcement_uuid: getAnnouncementUuid(item),
          announcement_source: 'internal',
        })),
        ...(this.announcementsSystem || []).map((item) => ({
          ...item,
          announcement_uuid: getAnnouncementUuid(item),
          announcement_source: 'system',
        })),
      ]

      const targets = allAnnouncements.filter(
        (announcement) =>
          announcement.announcement_uuid &&
          this.pendingNotShowAgainUuids.includes(
            announcement.announcement_uuid
          ) &&
          !announcement.announcement_receiver?.is_not_show_again
      )

      for (const announcement of targets) {
        const uuid = announcement.announcement_uuid
        try {
          const { company_uuid } = this.$store.state.authentication.company
          const employee_uuid = this.$store.state.authentication.user?.uuid

          if (announcement.announcement_source === 'system') {
            await this.addSystemAnnouncementIsNotShowAgain({
              announcement_uuid: uuid,
              company_uuid,
              employee_uuid,
            })
          } else {
            await this.addAnnouncementIsNotShowAgain({
              company_uuid,
              announcement_uuid: uuid,
              employee_uuid,
              body: {},
            })
          }

          this.notShowAgainSyncedUuids.push(uuid)
        } catch (error) {
          // Silently ignore so it doesn't block the home screen
        }
      }

      this.pendingNotShowAgainUuids = []
    },
    async markCurrentAnnouncementAsRead() {
      const announcement = this.currentAnnouncement
      if (!announcement) return

      const uuid = getAnnouncementUuid(announcement)
      if (!uuid) return

      const isRead =
        !!announcement.announcement_receiver?.is_read ||
        !!announcement.system_announcement_receiver?.is_read

      if (isRead || this.readAnnouncementUuids.includes(uuid)) {
        return
      }

      try {
        const { company_uuid } = this.$store.state.authentication.company
        const employee_uuid = this.$store.state.authentication.user?.uuid

        if (announcement.announcement_source === 'system') {
          await this.addSystemAnnouncementIsRead({
            announcement_uuid: uuid,
            company_uuid,
            employee_uuid,
          })
        } else {
          await this.addAnnouncementIsRead({
            company_uuid,
            announcement_uuid: uuid,
            employee_uuid,
            body: {},
          })
        }

        this.readAnnouncementUuids.push(uuid)
      } catch (error) {
        // Silently ignore so it doesn't block viewing the announcement
      }
    },
    async loadDataApi() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const payload = {
          company_uuid,
          employee_uuid: this.user.uuid,
        }

        await Promise.all([
          this.fetchCompany(company_uuid),
          this.getEmployeePolicy(payload),
        ])
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
  },
}
</script>
